import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { EndpointService } from '@app/core';
import {
  Forma,
  ValoresEspecificos,
  DefaultDocument
} from '@app/shared';

@Injectable()
export class CondictionDocumentDataService {
  constructor(private http: HttpClient, private toastr: ToastrService, private api: EndpointService) { }

  /**
   * Consulta la forma
   *
   * @param {number} idForm
   * @returns {Observable<Forma>}
   * @memberof CondictionDocumentDataService
   */
  getForm(idForm: number): Observable<Forma> {
    return new Observable(obs => {
      this.http.skipErrorHandler().get<Forma>(this.api.get('dynamicForm', [ idForm ])).subscribe(
        form => {
          form.sub_formas.forEach(subForm => {
            subForm.campos.sort((a, b) => a.orden - b.orden);
          });
          obs.next(form);
        },
        err => {
          if (err.status !== 401 && err.status !== 403) {
            this.toastr.error('Fallo del sistema', 'Error de operación');
          }
          obs.error(err);
        }
      );
    });
  }

  /**
   * Realiza la consulta de las columnas specificas de una maestra
   *
   * @param {*} structure
   * @returns {Promise<ValoresEspecificos[]>}
   * @memberof CondictionDocumentDataService
   */
  getColumnsSpecificMasterTable(structure: any): Promise<ValoresEspecificos[]> {
    return new Promise((resolve, reject) => {
      this.http.post<ValoresEspecificos[]>(this.api.get('masterTableSpecificInformation'),
        { estructura: structure }).subscribe(
          specificValues => {
            resolve(specificValues);
          },
          err => {
            reject(err);
          }
        );
    });
  }

  /**
   * Consulta los documentos para condicionar en la forma
   *
   * @returns {Observable<DefaultDocument[]>}
   * @memberof CondictionDocumentDataService
   */
  getDefaultDocuments(): Observable<DefaultDocument[]> {
    return new Observable(obs => {
      this.http.get<DefaultDocument[]>(this.api.get('defaultDocument')).subscribe(
        res => {
          obs.next(res);
        },
        err => {
          obs.error(err);
        }
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/creation-dynamic-component/condictions-documents/shared/condiction-documents.data.service.ts